import { gql } from '@apollo/client';

export const GET_CONVERSATION_ID = gql`
  query Chat_getConversationId {
    chat_getConversationId {
      conversationId
    }
  }
`;
